import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import './style.css'

const ArticleLocationInfo = ({ quantity, location }) => {
	const showQuantity = useSelector(
		(state) => !state.app.settings.featureSettings.hideRollingStockQuantity
	)

	return (
		<div className="articleLocationInfo">
			<div className="locationInfo header">
				<span>{location && 'Location'}</span>
				{showQuantity && <span>{quantity && 'Quantity'}</span>}
			</div>
			<div className="locationInfo">
				<span>{location}</span>
				{showQuantity && <span>{quantity}</span>}
			</div>
		</div>
	)
}

ArticleLocationInfo.propTypes = {
	quantity: PropTypes.number,
	location: PropTypes.string,
}

export default ArticleLocationInfo
